var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEncounterInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 7,
    fill: "#959CA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 16.125V25.5L24 29.25H14.625C13.5703 29.25 12.75 28.4297 12.75 27.375V16.125C12.75 15.1094 13.5703 14.25 14.625 14.25H25.875C26.8906 14.25 27.75 15.1094 27.75 16.125ZM24 20.8125C24 20.6562 23.8438 20.5 23.6875 20.5H21.5V18.3125C21.5 18.1562 21.3438 18 21.1875 18H19.3125C19.1172 18 19 18.1562 19 18.3125V20.5H16.8125C16.6172 20.5 16.5 20.6562 16.5 20.8125V22.6875C16.5 22.8828 16.6172 23 16.8125 23H19V25.1875C19 25.3828 19.1172 25.5 19.3125 25.5H21.1875C21.3438 25.5 21.5 25.3828 21.5 25.1875V23H23.6875C23.8438 23 24 22.8828 24 22.6875V20.8125ZM9 24.5625V15.1875C9 12.6094 11.0703 10.5 13.6875 10.5H23.0625C23.5703 10.5 24 10.9297 24 11.4375C24 11.9844 23.5703 12.375 23.0625 12.375H13.6875C12.125 12.375 10.875 13.6641 10.875 15.1875V24.5625C10.875 25.1094 10.4453 25.5 9.9375 25.5C9.39062 25.5 9 25.1094 9 24.5625Z",
    fill: "#C080B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncounterInformation);
export default __webpack_public_path__ + "static/media/encounter-information.48d47413.svg";
export { ForwardRef as ReactComponent };